import { PropertySearch } from '__generated__/api';

export const getMatchingFilterOption = (value: any, sortAndFilter: PropertySearch._SortAndFilter): PropertySearch._Options | null => {
  if (sortAndFilter.options.length > 0) {
    const result = sortAndFilter.options.find(option => option.value === value);

    return result ? result : null;
  }

  return null;
};
